(function($, Drupal, drupalSettings) {

  Drupal.webform = Drupal.webform || {};
  Drupal.webform.select2 = Drupal.webform.select2 || {};
  Drupal.webform.select2.options = Drupal.webform.select2.options || {};
  Drupal.webform.select2.options.width = Drupal.webform.select2.options.width || '100%';
  Drupal.webform.select2.options.widthInline = Drupal.webform.select2.options.widthInline || '50%';

  Drupal.behaviors.testing_form = {
    attach: function (context, settings) {

      if ($('body').hasClass('page--testing-services')) {
        var options = {};
        options.width = Drupal.webform.select2.options.widthInline;
        options = $.extend(options, Drupal.webform.select2.options);
        options.placeholder = "Select test";
        $('.webform-submission-testing-services-order-form-test-form select').select2(options);
      }

      $('.testing-serices-popup-close').click(function() {
        $('.ui-dialog-titlebar-close').trigger('click');
      });

      $('body.page--testing-services .component--mbm_button_001 a').click(function (event) {

        event.preventDefault();

        var empty = 0;

        if($('.webform-submission-testing-service-order-form-addre-form #edit-address-line-1--2').val().length == 0) {
          empty += 1;
        }
        if($('.webform-submission-testing-service-order-form-addre-form #edit-address-line-2--2').val().length == 0) {
          empty += 1;
        }
        if($('.webform-submission-testing-service-order-form-addre-form #edit-address-line-3--2').val().length == 0) {
          empty += 1;
        }
        if($('.webform-submission-testing-service-order-form-addre-form #edit-country--2').val().length == 0) {
          empty += 1;
        }
        if($('.webform-submission-testing-service-order-form-addre-form #edit-city--2').val().length == 0) {
          empty += 1;
        }
        if($('.webform-submission-testing-service-order-form-addre-form #edit-postcode--2').val().length == 0) {
          empty += 1;
        }

        if (empty > 0) {
          $('.testing-services-order-form-sub-button input').trigger('click');
        } else {
          $('.testing-services-order-form-main input').trigger('click');
        }

      });

    }
  }; // Drupal.behaviors.testing_form

})(jQuery, Drupal, drupalSettings);
